/**
 * Brandner Product Realtime v2.0
 * Live-Updates fuer Einzelprodukt-Seiten (Artikelseite)
 *
 * KOMPLETT NEU: Eigener Timer-Countdown der zwischen Polls tickt
 *
 * Architektur:
 * - Server-Polling alle 3s fuer aktuelle Daten (Preis, Zeit, Status)
 * - Lokaler Countdown (setInterval 1s) der zwischen Polls tickt
 * - Server-Zeit ueberschreibt lokale Zeit bei jedem Poll
 * - Anti-Sniping sofort sichtbar bei Zeit-Extension
 * - UWA-Plugin-Timer wird versteckt, unser Timer wird angezeigt
 *
 * Features:
 * - Server-autoritativ: Server entscheidet ueber Auktionsende
 * - Synchron zwischen Clients: Alle sehen (fast) gleiche Zeit
 * - Anti-Sniping Animation bei Zeitverlaengerung
 * - Gewinner/Verlierer Status-Updates
 * - Auktionsende-Detection mit Animation
 *
 * @version 2.0.0
 */
(function($) {
    'use strict';

    var BRANDNER_DEBUG = (typeof brandnerProductRealtime !== 'undefined' && brandnerProductRealtime.debug) || false;
    function debugLog() { if (BRANDNER_DEBUG) console.log.apply(console, arguments); }
    function debugWarn() { if (BRANDNER_DEBUG) console.warn.apply(console, arguments); }

    var BrandnerProductRealtime = {
        // Polling
        pollInterval: null,
        lastHash: null,
        POLL_INTERVAL_MS: 3000,
        isPolling: false,

        // Countdown
        countdownInterval: null,
        localRemaining: 0,      // Lokale Countdown-Zeit (tickt jede Sekunde)
        serverRemaining: null,  // Letzte Server-Zeit (zum Vergleich)

        // End-Timestamp-basierte Berechnung (verhindert Timer-Spruenge)
        auctionEndTimestamp: null,  // Absoluter Unix-Timestamp des Auktionsendes
        serverOffset: 0,           // Differenz: server_time - client_time (Sekunden)
        offsetCalibrated: false,   // Wurde der Offset bereits kalibriert?

        // State
        productId: null,
        auctionEnded: false,
        initialized: false,
        initialTimeFromAttributes: false, // Schutz gegen Server-Fehler beim ersten Poll

        // Hat der eingeloggte User auf diese Auktion geboten? Monoton (einmal
        // geboten bleibt geboten). Quellen: PHP-Localize beim Pageload, eigene
        // Gebote (afterOwnBid), Poll-Responses. Noetig, weil Pusher-Payloads
        // (public channel) den User nicht kennen — ohne das Flag konnte der
        // Ueberboten-Status nach einem bid-update-Event nicht angezeigt werden.
        userHasBid: false,

        // Suspense-Modus (Timer bei 0, warte auf Server-Bestätigung)
        suspenseMode: false,
        suspenseTimeout: null,
        suspenseReloadTimeout: null,

        // Optimistisches Fenster (gesetzt von den Bid-UIs nach eigenem Gebot):
        // bis _optimisticUntil werden Server-Daten mit current_bid < _optimisticBid
        // als stale verworfen (Cache-Race direkt nach Gebotsabgabe)
        _optimisticUntil: 0,
        _optimisticBid: 0,

        // Status-Pin nach eigenem Gebot: Die Bid-Response ist autoritativ.
        // Bis _statusPinUntil duerfen Polls (2s-Cache/5s-Transient koennen stale sein)
        // den Hoechstbieter/Ueberboten-Status nicht zurueckdrehen.
        _statusPinUntil: 0,
        _statusPinWinning: false,

        // Gebotshistorie-Refresh (Tab "Gebotshistorie" auf der Produktseite)
        _lastHistoryKey: null,
        _historyLoading: false,

        /**
         * Berechnet remaining aus End-Timestamp (monoton fallend, keine Spruenge)
         */
        getSmoothedRemaining: function() {
            if (!this.auctionEndTimestamp) return this.localRemaining;
            var clientNow = Math.floor(Date.now() / 1000);
            var adjustedNow = clientNow + this.serverOffset;
            return Math.max(0, this.auctionEndTimestamp - adjustedNow);
        },

        init: function() {
            // Nur auf Single-Product
            if (!$('body').hasClass('single-product')) return;

            // Konfiguration pruefen
            if (typeof brandnerProductRealtime === 'undefined') {
                debugWarn('[BrandnerProductRealtime] Konfiguration fehlt');
                return;
            }

            this.productId = brandnerProductRealtime.productId;
            if (!this.productId) {
                debugWarn('[BrandnerProductRealtime] Keine Produkt-ID');
                return;
            }

            // wp_localize_script liefert Booleans als '1' / '' (String)
            this.userHasBid = !!brandnerProductRealtime.userHasBid;

            debugLog('[BrandnerProductRealtime] v2.0 Init fuer Produkt ' + this.productId);

            // Initiale Server-Zeit aus data-Attributen holen
            var $countdown = $('.uwa_auction_product_countdown');
            if ($countdown.length) {
                // Priorität 1: data-days/hours/minute/sec (clock_server Mode)
                // Diese Attribute enthalten bereits berechnete Werte
                var days = $countdown.attr('data-days');
                var hours = $countdown.attr('data-hours');
                var mins = $countdown.attr('data-minute');
                var secs = $countdown.attr('data-sec');

                if (days !== undefined || hours !== undefined) {
                    // clock_server Mode - Werte direkt verwenden
                    days = parseInt(days) || 0;
                    hours = parseInt(hours) || 0;
                    mins = parseInt(mins) || 0;
                    secs = parseInt(secs) || 0;
                    this.localRemaining = (days * 86400) + (hours * 3600) + (mins * 60) + secs;
                    this.serverRemaining = this.localRemaining;
                    // Schutz aktivieren wenn wir valide initiale Zeit haben
                    if (this.localRemaining > 0) {
                        this.initialTimeFromAttributes = true;
                    }
                    debugLog('[BrandnerProductRealtime] Init aus data-days/hours/minute/sec: ' + this.localRemaining + 's (Schutz: ' + this.initialTimeFromAttributes + ')');
                } else {
                    // Priorität 2: data-time als Enddatum (timer_jquery Mode)
                    // ACHTUNG: data-time enthält ein DATUM, nicht Sekunden!
                    var dataTime = $countdown.attr('data-time');
                    if (dataTime) {
                        // Prüfen ob es ein Datum oder Sekunden sind
                        if (dataTime.indexOf('-') !== -1 || dataTime.indexOf(':') !== -1) {
                            // Es ist ein Datum (z.B. "2026-02-04 15:00:00") - remaining berechnen
                            var endDate = new Date(dataTime.replace(' ', 'T')); // ISO-Format für zuverlässiges Parsing
                            var now = new Date();
                            var remaining = Math.floor((endDate - now) / 1000);
                            this.localRemaining = Math.max(0, remaining);
                            debugLog('[BrandnerProductRealtime] Init aus data-time (Datum): ' + dataTime + ' -> ' + this.localRemaining + 's');
                        } else {
                            // Es könnten Sekunden sein (numerisch)
                            this.localRemaining = parseInt(dataTime) || 0;
                            debugLog('[BrandnerProductRealtime] Init aus data-time (Sekunden): ' + this.localRemaining + 's');
                        }
                        this.serverRemaining = this.localRemaining;
                        // Schutz aktivieren wenn wir valide initiale Zeit haben
                        if (this.localRemaining > 0) {
                            this.initialTimeFromAttributes = true;
                        }
                    }
                }
            }

            debugLog('[BrandnerProductRealtime] Initiale Zeit: ' + this.localRemaining + 's');

            // UWA-Plugin-Timer uebernehmen (wartet auf React falls noetig)
            this.hidePluginTimer();

            // Lokalen Countdown starten (tickt jede Sekunde)
            this.startLocalCountdown();

            // Server-Polling starten (dynamisches Intervall)
            this.startPolling();
            this.poll(); // Sofort erstes Polling um aktuelle Server-Zeit zu bekommen

            // Visibility-Handler (pausiert bei Tab-Wechsel)
            this.initVisibilityHandler();

            this.initialized = true;
        },

        /**
         * Übernimmt die Kontrolle über den Timer
         * Falls das UWA-Plugin seinen React-Timer noch nicht gerendert hat,
         * generieren wir das HTML selbst.
         */
        hidePluginTimer: function() {
            var self = this;
            var $countdown = $('.uwa_auction_product_countdown');

            if ($countdown.length === 0) {
                debugWarn('[BrandnerProductRealtime] Kein Countdown-Element gefunden');
                return;
            }

            // Warten bis Timer-HTML vorhanden ist (React rendert async)
            // Oder selbst generieren wenn nach 1s immer noch leer
            var checkCount = 0;
            var maxChecks = 10; // Max 1 Sekunde warten (10 * 100ms)

            var checkAndInit = function() {
                var $sections = $countdown.find('.countdown_section');

                if ($sections.length >= 4) {
                    // React hat gerendert - wir ueberschreiben einfach die Werte
                    debugLog('[BrandnerProductRealtime] Timer-Struktur gefunden, uebernehme Kontrolle');
                } else if (checkCount >= maxChecks) {
                    // Timeout - selbst Timer-HTML generieren
                    debugLog('[BrandnerProductRealtime] Timer-HTML nicht gefunden, generiere selbst');
                    self.generateTimerHTML($countdown);
                } else {
                    checkCount++;
                    setTimeout(checkAndInit, 100);
                    return;
                }

                // Timer-Display initial setzen
                self.updateTimerDisplay(self.localRemaining);
            };

            checkAndInit();
        },

        /**
         * Generiert Timer-HTML falls UWA-Plugin es nicht tut
         * (z.B. wenn React-Script deaktiviert wurde)
         */
        generateTimerHTML: function($container) {
            var html = '<span class="countdown_row countdown_show3" id="uwa_auction_countdown">' +
                '<span class="countdown_section">' +
                    '<span class="countdown_amount">00</span><br>' +
                    '<span class="countdown_amount">TAGE</span>' +
                '</span>' +
                '<span class="countdown_section">' +
                    '<span class="countdown_amount">00</span><br>' +
                    '<span class="countdown_amount">STD</span>' +
                '</span>' +
                '<span class="countdown_section">' +
                    '<span class="countdown_amount">00</span><br>' +
                    '<span class="countdown_amount">MIN</span>' +
                '</span>' +
                '<span class="countdown_section">' +
                    '<span class="countdown_amount">00</span><br>' +
                    '<span class="countdown_amount">SEK</span>' +
                '</span>' +
            '</span>';

            $container.html(html);
            debugLog('[BrandnerProductRealtime] Timer-HTML generiert');
        },

        /**
         * Lokaler Countdown - tickt jede Sekunde
         * Wird bei jedem Server-Poll mit der aktuellen Server-Zeit synchronisiert
         */
        startLocalCountdown: function() {
            var self = this;

            this.countdownInterval = setInterval(function() {
                if (self.auctionEnded) {
                    clearInterval(self.countdownInterval);
                    return;
                }

                // Berechne remaining aus End-Timestamp (KEIN Dekrement mehr!)
                var remaining;
                if (self.auctionEndTimestamp && self.offsetCalibrated) {
                    remaining = self.getSmoothedRemaining();
                    self.localRemaining = remaining; // fuer Konsumenten wie getPollInterval-Fallback
                } else {
                    // Fallback bis erster Server-Sync
                    if (self.localRemaining > 0) self.localRemaining--;
                    remaining = self.localRemaining;
                }

                self.updateTimerDisplay(remaining);

                // Endphase: brandner-websocket.js drosselt das Polling auf 60s sobald
                // Pusher verbunden ist (ersetzt die adaptive setTimeout-Kette durch ein
                // starres setInterval). Fuer den Ende-Uebergang brauchen wir aber die
                // 1-1.5s-Kette — bei <30s Restzeit reaktivieren.
                if (remaining <= 30 && self.POLL_INTERVAL_MS > 3000 && !self.auctionEnded) {
                    self.POLL_INTERVAL_MS = 3000;
                    self.startPolling();
                    debugLog('[BrandnerProductRealtime] Endphase: adaptive Poll-Kette reaktiviert');
                }

                // Bei 0 angekommen - NICHT automatisch als beendet markieren!
                // Server ist autoritativ und sagt uns wann es wirklich vorbei ist
                if (remaining <= 0 && !self.auctionEnded && !self.suspenseMode) {
                    self.updateTimerDisplay(0);
                    self.startSuspenseMode();
                }
            }, 1000);
        },

        /**
         * Gibt das aktuelle Polling-Intervall zurueck (dynamisch basierend auf Timer-Status)
         * WICHTIG: getSmoothedRemaining() verwenden — localRemaining wird nach der
         * Offset-Kalibrierung nicht mehr dekrementiert und bliebe auf dem Pageload-Wert
         * stehen (das kritische 1.5s-Intervall wuerde nie aktiv).
         */
        getPollInterval: function() {
            if (this.suspenseMode) return 1000;      // Suspense: 1s (schnellste Antwort)
            var remaining = this.auctionEndTimestamp ? this.getSmoothedRemaining() : this.localRemaining;
            if (remaining < 30) return 1500;         // Kritisch: 1.5s
            return 3000;  // Normal: 3s
        },

        /**
         * Startet Suspense-Modus wenn Timer 0 erreicht
         * Pulsierendes 00:00:00 erzeugt Spannung: "Hat es geklappt?" / "Kommt Extension?"
         */
        startSuspenseMode: function() {
            if (this.suspenseMode) return;
            this.suspenseMode = true;

            debugLog('[BrandnerProductRealtime] Suspense-Modus gestartet - warte auf Server...');

            var $timer = $('#uwa_auction_countdown, .uwa_auction_product_countdown').first();
            $timer.addClass('timer-suspense');

            // Kurz nach Timer-Ende: Auktionsverarbeitung serverseitig anstossen (eliminiert
            // Cron-Delay). Nur 1,5s Wartezeit (vorher 5s) — die Spanne reicht, damit eine
            // eventuelle Anti-Snipe-Verlaengerung via Poll landet; sie wird unten geprueft.
            // Mit Nonce (sonst scheitert der Endpoint an check_ajax_referer).
            var self = this;
            var triggerKey = 'brandner_close_triggered_' + this.productId;
            var closeNonce = brandnerProductRealtime.closeNonce || '';
            try {
                if (!sessionStorage.getItem(triggerKey)) {
                    setTimeout(function() {
                        // Falls inzwischen verlaengert/beendet: nicht ausloesen
                        if (!self.suspenseMode || self.auctionEnded) return;
                        if (!closeNonce) return;
                        sessionStorage.setItem(triggerKey, '1');
                        $.ajax({
                            url: brandnerProductRealtime.ajaxUrl,
                            type: 'POST',
                            data: { action: 'brandner_trigger_auction_close', nonce: closeNonce },
                            timeout: 10000
                        });
                        debugLog('[BrandnerProductRealtime] Auction-Close-Trigger gefeuert');
                    }, 1500);
                }
            } catch(e) { /* sessionStorage nicht verfuegbar */ }

            // Sofort einen Poll ausloesen fuer schnellste Server-Antwort
            this.pollServerData();

            // Fallback-Kette statt hartem 6s-Reload: unter Last (langsame AJAX-
            // Antworten) machte der fruehe Reload alles schlimmer — die ungecachte
            // Produktseite laedt sekundenlang und auf bereits beendet geladenen
            // Seiten entstand eine Reload-Schleife. Erst weiter pollen; Reload nur
            // als letzte Rettung nach 20s und NIE wenn der Server die Seite schon
            // als beendet gerendert hat.
            this.suspenseTimeout = setTimeout(function() {
                if (!self.auctionEnded && self.suspenseMode) {
                    debugLog('[BrandnerProductRealtime] Suspense 6s - weiter pollen statt Reload');
                    self.poll();
                }
            }, 6000);
            this.suspenseReloadTimeout = setTimeout(function() {
                var pageLoadedEnded = (typeof brandnerProductRealtime !== 'undefined' && brandnerProductRealtime.isEnded);
                if (!self.auctionEnded && self.suspenseMode && !pageLoadedEnded) {
                    debugLog('[BrandnerProductRealtime] Suspense-Timeout (20s) - lade Seite neu');
                    location.reload();
                }
            }, 20000);
        },

        /**
         * Beendet Suspense-Modus (nach Extension oder Auktionsende)
         */
        exitSuspenseMode: function() {
            if (!this.suspenseMode) return;
            this.suspenseMode = false;
            clearTimeout(this.suspenseTimeout);
            clearTimeout(this.suspenseReloadTimeout);

            var $timer = $('#uwa_auction_countdown, .uwa_auction_product_countdown').first();
            $timer.removeClass('timer-suspense');

            debugLog('[BrandnerProductRealtime] Suspense-Modus beendet');
        },

        /**
         * Direkter Server-Poll (fuer Suspense-Modus)
         */
        pollServerData: function() {
            this.poll();
        },

        /**
         * Server-Polling - holt aktuelle Daten (Intervall dynamisch)
         */
        poll: function() {
            if (this.isPolling || this.auctionEnded) return;
            this.isPolling = true;

            var self = this;
            $.ajax({
                url: brandnerProductRealtime.ajaxUrl,
                type: 'POST',
                data: {
                    action: 'brandner_get_auction_data',
                    product_id: this.productId,
                    hash: this.lastHash || ''
                },
                timeout: 5000,
                success: function(response) {
                    if (response.success && response.data) {
                        // remaining IMMER synchronisieren (auch wenn Hash gleich)
                        if (response.data.remaining !== undefined) {
                            self.syncServerTime(response.data.remaining, response.data);
                        }

                        // Andere Updates nur wenn sich etwas geaendert hat
                        if (response.data.changed !== false) {
                            self.updatePage(response.data);
                        }
                        self.lastHash = response.data.hash;
                    }
                },
                error: function(xhr, status, error) {
                    debugWarn('[BrandnerProductRealtime] AJAX Fehler:', error);
                },
                complete: function() {
                    self.isPolling = false;
                }
            });
        },

        /**
         * Synchronisiert die lokale Zeit mit der Server-Zeit
         * Erkennt Anti-Sniping (Zeitverlaengerung)
         */
        syncServerTime: function(newServerRemaining, data) {
            var serverRemaining = parseInt(newServerRemaining) || 0;
            var oldEndTimestamp = this.auctionEndTimestamp;

            // Server-Offset kalibrieren (server_time - client_time)
            if (data.server_time) {
                var clientNow = Math.floor(Date.now() / 1000);
                this.serverOffset = parseInt(data.server_time) - clientNow;
                this.offsetCalibrated = true;
            }

            // End-Timestamp setzen
            if (data.end_timestamp) {
                this.auctionEndTimestamp = parseInt(data.end_timestamp);
            } else if (data.server_time && serverRemaining > 0) {
                // Fallback: end_timestamp aus server_time + remaining berechnen
                this.auctionEndTimestamp = parseInt(data.server_time) + serverRemaining;
            }

            // SCHUTZ: Wenn Server 0 zurueckgibt aber wir haben valide initiale Zeit aus Attributen
            if (serverRemaining === 0 && this.getSmoothedRemaining() > 60 && this.initialTimeFromAttributes) {
                debugWarn('[BrandnerProductRealtime] Server gab remaining=0, aber smoothed=' +
                             this.getSmoothedRemaining() + 's - ignoriert');
                this.initialTimeFromAttributes = false;
                return;
            }
            if (serverRemaining > 0 && this.initialTimeFromAttributes) {
                debugLog('[BrandnerProductRealtime] Server-Sync erfolgreich, Schutz deaktiviert');
                this.initialTimeFromAttributes = false;
            }

            // Anti-Sniping Detection: End-Timestamp VERLAENGERT
            if (oldEndTimestamp && this.auctionEndTimestamp > oldEndTimestamp + 5) {
                var extension = this.auctionEndTimestamp - oldEndTimestamp;
                debugLog('[BrandnerProductRealtime] Anti-Sniping erkannt! +' + extension + 's');
                this.exitSuspenseMode();
                this.showTimeExtension(extension);
            }

            // Bei Server-Zeit > 0: Suspense beenden (Timer laeuft wieder)
            if (serverRemaining > 0 && this.suspenseMode) {
                this.exitSuspenseMode();
            }

            // serverRemaining merken (fuer Debug-Logging)
            this.serverRemaining = serverRemaining;

            // localRemaining als Fallback aktualisieren (NUR wenn End-Timestamp nicht verfuegbar)
            if (!this.offsetCalibrated) {
                this.localRemaining = serverRemaining;
            }

            // data-time Attribut aktualisieren
            var $countdown = $('.uwa_auction_product_countdown[data-time]');
            if ($countdown.length && this.auctionEndTimestamp) {
                $countdown.attr('data-time', this.auctionEndTimestamp);
            }
        },

        /**
         * Aktualisiert die Seite mit neuen Daten
         *
         * @return {boolean} false wenn die Daten als stale verworfen wurden
         *                   (Aufrufer darf dann lastHash nicht setzen)
         */
        updatePage: function(data) {
            // Stale-Schutz im optimistischen Fenster: direkt nach eigenem Gebot
            // koennen Polls noch alte Cache-Daten liefern (niedrigeres Gebot als
            // das gerade abgegebene). Auktionsende wird nie verworfen.
            if (data.status !== 'ended' &&
                this._optimisticUntil && Date.now() < this._optimisticUntil &&
                parseFloat(data.current_bid) < this._optimisticBid) {
                debugLog('[BrandnerProductRealtime] Stale-Daten im optimistischen Fenster verworfen');
                return false;
            }

            // 1. Preis aktualisieren
            this.updatePrice(data);

            // 2. Status aktualisieren (Gewinner/Verlierer)
            this.updateStatus(data);

            // 3. Bid-Count aktualisieren
            this.updateBidCount(data);

            // 4. Gebotshistorie nachladen wenn sich die Gebotslage geaendert hat
            this.maybeRefreshHistory(data);

            // 5. Auktionsende pruefen
            if (data.status === 'ended') {
                this.handleAuctionEnd(data);
            }

            return true;
        },

        /**
         * Stoesst den Historie-Refresh an, wenn sich die Gebotslage geaendert hat.
         * Beim ersten Aufruf nach Pageload wird nur der Schluessel gemerkt —
         * die Historie wurde gerade erst server-seitig gerendert.
         */
        maybeRefreshHistory: function(data) {
            if (data.current_bid === undefined && data.bid_count === undefined) return;

            var key = String(data.current_bid) + '|' + String(data.bid_count);
            if (this._lastHistoryKey === null) {
                this._lastHistoryKey = key;
                return;
            }
            if (this._lastHistoryKey === key) return;
            this._lastHistoryKey = key;
            this.refreshHistory();
        },

        /**
         * Holt die server-gerenderte Gebotshistorie (user-spezifisch maskiert)
         * und ersetzt den Tabellen-Inhalt. Markup kommt aus
         * brandner_get_auction_history_table_html() (mu-plugins/brandner-fast-ajax.php).
         */
        refreshHistory: function() {
            // ALLE Instanzen der Historie-Tabelle aktualisieren: brandner_move_bids_section
            // klont die Tabelle beim Pageload in das "Gebote (N)"-Popup (cloneNode) —
            // ein id-Selektor traefe nur das versteckte Original und der User saehe im
            // Popup fuer immer den stalen Klon (Bug: "Historie aktualisiert sich nicht").
            // Klassen-Selektor matcht Original + Popup-Klon und ueberlebt auch UWAs
            // AJAX-Re-Render mit kaputtem id-Attribut (class-uwa-product.php:
            // Quote schliesst vor der Produkt-ID).
            var $tables = $('.uwa_bids_history_data table.auction-history-table');
            if (!$tables.length) {
                $tables = $('#auction-history-table-' + this.productId);
            }
            if (!$tables.length || this._historyLoading) return;

            var self = this;
            this._historyLoading = true;

            $.ajax({
                url: brandnerProductRealtime.ajaxUrl,
                type: 'POST',
                data: {
                    action: 'brandner_get_auction_history',
                    product_id: this.productId
                },
                timeout: 5000,
                success: function(response) {
                    if (response.success && response.data && response.data.html !== undefined) {
                        $tables.each(function() {
                            $(this).html(response.data.html);
                        });
                        if (response.data.bid_count !== undefined) {
                            self.updateBidCountDisplays(response.data.bid_count);
                        }
                        debugLog('[BrandnerProductRealtime] Gebotshistorie aktualisiert (' +
                            response.data.bid_count + ' Gebote, ' + $tables.length + ' Tabellen)');
                    }
                },
                error: function(xhr, status, error) {
                    debugWarn('[BrandnerProductRealtime] Historie-Refresh Fehler:', error);
                },
                complete: function() {
                    self._historyLoading = false;
                }
            });
        },

        /**
         * Aktualisiert die Preis-Anzeige
         */
        updatePrice: function(data) {
            if (!data.current_bid_formatted) return;

            // Temporaeres Element zum HTML-Dekodieren
            var tempDiv = document.createElement('div');
            tempDiv.innerHTML = data.current_bid_formatted;
            var newText = tempDiv.textContent || tempDiv.innerText;

            // Plugin-Preis aktualisieren
            var $pluginPrice = $('.woo-ua-auction-price .amount, .woo-ua-auction-price bdi');
            if ($pluginPrice.length) {
                var oldPluginText = $pluginPrice.first().text().trim();
                if (oldPluginText !== newText) {
                    $pluginPrice.first().text(newText);
                    // Puls-Animation
                    $pluginPrice.first().addClass('price-updated');
                    setTimeout(function() {
                        $pluginPrice.first().removeClass('price-updated');
                    }, 600);
                }
            }

            // Custom Preis-Box aktualisieren
            var $customPrice = $('.brandner-current-bid .bid-value');
            if ($customPrice.length) {
                // Startgebot-Anzeige nicht mit 0€ überschreiben
                var $bidBox = $('.brandner-current-bid');
                if (data.current_bid <= 0 && $bidBox.hasClass('bid-status-startgebot')) {
                    // Opening Price beibehalten, nicht mit 0€ überschreiben
                } else {
                    var oldText = $customPrice.text().trim();
                    if (oldText !== newText) {
                        $customPrice.text(newText);
                        // Puls-Animation
                        $customPrice.addClass('bid-updated');
                        setTimeout(function() {
                            $customPrice.removeClass('bid-updated');
                        }, 600);
                        debugLog('[BrandnerProductRealtime] Preis aktualisiert: ' + oldText + ' -> ' + newText);
                    }
                }
            }

            // Label von "Startgebot:" zu "Aktuelles Gebot:" wechseln
            var $bidLabel = $('.brandner-current-bid .bid-label');
            var $bidBox = $('.brandner-current-bid');
            if ($bidLabel.length && data.current_bid > 0 && $bidBox.hasClass('bid-status-startgebot')) {
                $bidLabel.text('Aktuelles Gebot:');
                $bidBox.removeClass('bid-status-startgebot');
            }
        },

        /**
         * Aktualisiert die Timer-Anzeige mit berechneten Werten
         * Funktioniert mit:
         * - React-generiertem Timer (countdown_section > countdown_amount)
         * - Selbst-generiertem Timer (gleiche Struktur)
         * - Alternative UWA-Struktur (days/hours/minutes/seconds Klassen)
         * - Custom Brandner-Timer (brandner-product-timer)
         */
        updateTimerDisplay: function(totalSeconds) {
            totalSeconds = Math.max(0, parseInt(totalSeconds) || 0);

            // Berechne Tage, Stunden, Minuten, Sekunden
            var days = Math.floor(totalSeconds / 86400);
            var hours = Math.floor((totalSeconds % 86400) / 3600);
            var minutes = Math.floor((totalSeconds % 3600) / 60);
            var seconds = totalSeconds % 60;

            // Formatierte Werte
            var daysStr = this.pad(days);
            var hoursStr = this.pad(hours);
            var minsStr = this.pad(minutes);
            var secsStr = this.pad(seconds);

            // Methode 1: countdown_section Struktur (React oder selbst-generiert)
            // Struktur: .countdown_section > .countdown_amount (erster = Zahl, zweiter = Label)
            var $countdown = $('#uwa_auction_countdown, .uwa_auction_product_countdown').first();
            if ($countdown.length) {
                var $sections = $countdown.find('.countdown_section');

                if ($sections.length >= 4) {
                    // Tage (Section 0)
                    $sections.eq(0).find('.countdown_amount').first().text(daysStr);
                    // Stunden (Section 1)
                    $sections.eq(1).find('.countdown_amount').first().text(hoursStr);
                    // Minuten (Section 2)
                    $sections.eq(2).find('.countdown_amount').first().text(minsStr);
                    // Sekunden (Section 3)
                    $sections.eq(3).find('.countdown_amount').first().text(secsStr);
                }
            }

            // Methode 2: Alternative Klassen-Selektoren
            var $countdownAlt = $('.uwa_auction_product_countdown');
            if ($countdownAlt.length) {
                // .days/.hours/.minutes/.seconds mit .uwa-auction-countdown-only-digit
                $countdownAlt.find('.days .uwa-auction-countdown-only-digit').text(days);
                $countdownAlt.find('.hours .uwa-auction-countdown-only-digit').text(hoursStr);
                $countdownAlt.find('.minutes .uwa-auction-countdown-only-digit').text(minsStr);
                $countdownAlt.find('.seconds .uwa-auction-countdown-only-digit').text(secsStr);
            }

            // Methode 3: Brandner custom timer (falls vorhanden)
            $('.brandner-product-timer').each(function() {
                $(this).find('.timer-days').text(daysStr);
                $(this).find('.timer-hours').text(hoursStr);
                $(this).find('.timer-mins').text(minsStr);
                $(this).find('.timer-secs').text(secsStr);
            });
        },

        /**
         * Padding fuer einstellige Zahlen
         */
        pad: function(num) {
            return (num < 10 ? '0' : '') + num;
        },

        /**
         * Zeigt Anti-Sniping Animation und Badge
         */
        showTimeExtension: function(seconds) {
            debugLog('[BrandnerProductRealtime] Zeit verlaengert: +' + seconds + 's');

            // Timer-Container finden
            var $timer = $('#uwa_auction_countdown, .uwa_auction_product_countdown').first();
            if ($timer.length === 0) return;

            // Konfigurierten Extend-Time-Wert verwenden (falls gesetzt)
            var extendTime = brandnerProductRealtime.extendTimeSeconds || seconds;

            // Badge erstellen
            var $badge = $('<span class="timer-extended-badge">+' + extendTime + 's</span>');

            $timer.css('position', 'relative');
            $timer.addClass('timer-extended');
            $timer.append($badge);

            // Nach 2.5 Sekunden Animation beenden
            setTimeout(function() {
                $timer.removeClass('timer-extended');
                $badge.remove();
            }, 2500);

            // Sound-Feedback (optional, wenn Audio-Element vorhanden)
            this.playExtensionSound();
        },

        /**
         * Spielt optional einen Sound bei Zeit-Extension
         */
        playExtensionSound: function() {
            // Optional: Kann spaeter mit Audio-Element implementiert werden
            // var audio = document.getElementById('brandner-extend-sound');
            // if (audio) audio.play();
        },

        /**
         * Aktualisiert den Gewinner/Verlierer-Status
         * Verwendet jetzt user_has_bid aus Server-Response (zuverlaessiger als DOM-Check)
         */
        updateStatus: function(data) {
            var $currentBidBox = $('.brandner-current-bid');
            var currentUserId = brandnerProductRealtime.currentUserId;

            if (!currentUserId) return;

            // Server-Response ist die zuverlaessigste Quelle
            var isWinning = data.is_winning === true;

            // userHasBid ist monoton — Poll-Responses halten das Flag aktuell.
            // Pusher-Payloads liefern user_has_bid nur als Karten-Heuristik
            // (auf der Produktseite gibt es keine Karte -> immer false), daher
            // zaehlt zusaetzlich das lokale Flag.
            if (data.user_has_bid === true) this.userHasBid = true;
            var userHasBid = data.user_has_bid === true || this.userHasBid;

            // Status-Pin: direkt nach eigenem Gebot ist die Bid-Response autoritativ.
            // Stale Poll-Daten (Cache-Race) duerfen "Hoechstbieter" nicht faelschlich
            // auf "Ueberboten" zurueckdrehen (und umgekehrt). Auktionsende gewinnt immer.
            if (data.status !== 'ended' && this._statusPinUntil && Date.now() < this._statusPinUntil) {
                isWinning = this._statusPinWinning;
                userHasBid = true;
            }

            // Brandner Custom Bid-Box Status
            if ($currentBidBox.length) {
                $currentBidBox.removeClass('bid-status-winning bid-status-outbid bid-status-none');

                if (isWinning) {
                    $currentBidBox.addClass('bid-status-winning');
                } else if (userHasBid && data.current_bidder && parseInt(data.current_bidder) > 0) {
                    // User hat geboten UND jemand anderes ist Hoechstbietender -> ueberboten
                    $currentBidBox.addClass('bid-status-outbid');
                }

            }

            // UWA Plugin uwa_winning/uwa_losing Spans
            if (isWinning) {
                $('.uwa_losing').hide();
                $('.uwa_winning').show();
                this.setStatusBadge('winning');
            } else if (userHasBid && data.current_bidder && parseInt(data.current_bidder) > 0) {
                // User hat geboten aber ist nicht Hoechstbietender
                $('.uwa_winning').hide();
                $('.uwa_losing').show();
                this.setStatusBadge('outbid');
            }
        },

        /**
         * Schreibt den Status-Badge-Text (span.uwa_imgtext / p.uwa_detailtext).
         * hide()/show() allein reicht nicht: UWA rendert nur EINEN Status-Span —
         * beim Statuswechsel via Poll/Pusher existiert der Gegen-Span nicht
         * (z.B. "Ueberboten", waehrend "Hoechstbietender" gerendert war).
         * Strings identisch zu den Bid-Response-Handlern (brandner-custom.php)
         * und brandner-realtime.js. Idempotent: schreibt nur bei Wechsel.
         */
        setStatusBadge: function(status) {
            var cls = (status === 'winning') ? 'uwa_winning' : 'uwa_losing';
            var html = (status === 'winning')
                ? '<span class="uwa_winning">Höchstbietender</span>'
                : '<span class="uwa_losing">Überboten</span>';
            $('span.uwa_imgtext, p.uwa_detailtext').each(function() {
                var $el = $(this);
                if ($el.children('span.' + cls).length && $el.children('span').length === 1) {
                    return; // bereits korrekt — kein DOM-Churn pro Poll
                }
                $el.html(html);
            });
        },

        /**
         * Aktualisiert die Gebots-Anzahl
         */
        updateBidCount: function(data) {
            if (data.bid_count === undefined) return;
            this.updateBidCountDisplays(data.bid_count);
        },

        /**
         * Schreibt die Gebots-Anzahl in ALLE Anzeigen: UWA-Zaehler,
         * "Gebote (N)"-Button (brandner_move_bids_section) und Popup-Titel.
         * Button und Titel wurden bisher nur beim Pageload gesetzt und blieben stale.
         */
        updateBidCountDisplays: function(count) {
            $('.uwa-total-bids .count, .bid-count-value').text(count);
            $('.brandner-gebote-btn .gebote-count').text('(' + count + ')');
            $('.brandner-bids-popup-title').text('Alle Gebote (' + count + ')');
        },

        /**
         * Behandelt Auktionsende
         */
        handleAuctionEnd: function(data) {
            if (this.auctionEnded) return;
            this.auctionEnded = true;

            debugLog('[BrandnerProductRealtime] Auktion beendet (Server bestaetigt)');

            // Suspense-Modus beenden (falls aktiv)
            this.exitSuspenseMode();

            // Intervalle stoppen
            if (this.pollInterval) {
                clearTimeout(this.pollInterval);
                this.pollInterval = null;
            }
            if (this.countdownInterval) {
                clearInterval(this.countdownInterval);
                this.countdownInterval = null;
            }

            // Timer auf 0 setzen
            this.localRemaining = 0;
            this.updateTimerDisplay(0);

            // data-time auch auf 0 setzen
            var $countdown = $('.uwa_auction_product_countdown[data-time]');
            if ($countdown.length) {
                $countdown.attr('data-time', 0);
            }

            // "BEENDET" Markierung + Ergebnis SOFORT an Ort und Stelle anzeigen (kein Warten)
            this.showEndedState();
            var verdict = this.verdictFor(data);
            var isWinner = (verdict === 'won');
            this.renderResultBanner(verdict, data);

            // Bestehende UWA-Status-Spans konsistent halten
            if (verdict === 'won') { $('.uwa_losing').hide(); $('.uwa_winning').show(); }

            // War die Seite bereits beendet geladen? Dann hat der Server den End-Zustand
            // schon gerendert -> KEINE Animation, KEIN Reload. Storage-UNABHAENGIG (nutzt die
            // serverseitig lokalisierte isEnded-Flagge), verhindert die Reload-Schleife des
            // Gewinners auch wenn localStorage blockiert ist (Private Mode/Quota).
            // Nur ein ECHTER Live-Uebergang (Seite lief beim Laden) feiert + laedt nach.
            var pageLoadedEnded = (typeof brandnerProductRealtime !== 'undefined' && brandnerProductRealtime.isEnded);
            if (pageLoadedEnded) {
                debugLog('[BrandnerProductRealtime] Seite bereits beendet geladen — nur Ergebnis, keine Animation/Reload');
                return;
            }

            if (isWinner) {
                // Gewinner: Glueckwunsch-Animation, danach den serverseitigen
                // End-Zustand INLINE nachbilden statt location.reload() — die
                // ungecachte Produktseite laedt zu lange (Betreiber-Entscheidung
                // 2026-06-11). Empirisch verifiziert (Staging, Los 21883): der
                // Reload lieferte nur die Gewinner-Box, keinen Bezahl-Flow
                // (Projekt-Auktionen laufen ueber Sammelbestellungen).
                if (typeof BrandnerAuctionAnimations !== 'undefined') {
                    var productTitle = $('.product_title').text() || '';
                    BrandnerAuctionAnimations.showFullscreenWinner(productTitle, data.current_bid_formatted);
                }
                this.renderWinnerEndState(data);
            } else {
                // Verlierer/Aussenstehende: KEIN Reload — das Ergebnis ('Los beendet' bzw.
                // 'Mindestpreis nicht erreicht') bleibt sofort und ruhig an Ort und Stelle.
                debugLog('[BrandnerProductRealtime] Beendet ohne Zuschlag fuer diesen User — Ergebnis inline, kein Reload');
            }
        },

        /**
         * Bildet den serverseitigen Gewinner-End-Zustand inline nach — Markup und
         * Verhalten identisch zum Gewinner-Zweig von brandner_finished_auction_js()
         * (brandner-custom.php), der nach einem Reload greifen wuerde: Live-UI im
         * Zielbereich verstecken, Gewinner-Box (Glueckwunsch + Gewinngebot + Badge)
         * einfuegen. Ersetzt den frueheren location.reload() nach dem Zuschlag.
         */
        renderWinnerEndState: function(data) {
            if ($('.brandner-winner-box').length) return;

            var targetArea = document.querySelector('.elementor-widget-woocommerce-product-add-to-cart') ||
                             document.querySelector('.elementor-widget-woocommerce-product-content') ||
                             document.querySelector('.summary') ||
                             document.querySelector('.main-content');
            if (!targetArea) return;

            Array.prototype.forEach.call(targetArea.children, function(child) {
                if (child.classList && child.classList.contains('brandner-auction-result')) return;
                child.style.display = 'none';
            });

            // Ergebnis-Banner sichtbar halten (wie auf der neu geladenen Seite):
            // wurde sein Traeger-Element gerade mitversteckt, in den Zielbereich heben.
            var banner = document.querySelector('.brandner-auction-result');
            if (banner && banner.offsetParent === null) {
                targetArea.appendChild(banner);
            }

            // Gewinngebot als Text (wc_price-HTML dekodieren, wie updatePrice)
            var winningBid = '';
            if (data && data.current_bid_formatted) {
                var tmp = document.createElement('div');
                tmp.innerHTML = data.current_bid_formatted;
                winningBid = (tmp.textContent || tmp.innerText || '').trim();
            }

            var winnerBox = document.createElement('div');
            winnerBox.className = 'brandner-winner-box';
            winnerBox.innerHTML =
                '<div class="winner-header">' +
                    '<svg class="winner-checkmark" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">' +
                        '<path d="M20 6L9 17l-5-5"/>' +
                    '</svg>' +
                    '<div class="winner-title">' +
                        '<h3>Herzlichen Glückwunsch!</h3>' +
                        '<p>Sie haben diese Auktion gewonnen</p>' +
                    '</div>' +
                '</div>' +
                '<div class="winner-details">' +
                    '<div class="winner-bid-row">' +
                        '<span class="label">Ihr Gewinngebot</span>' +
                        '<span class="amount">' + (winningBid || '&mdash;') + '</span>' +
                    '</div>' +
                '</div>' +
                '<div class="winner-badge-row"><span class="winner-badge">&#10003; Zuschlag erhalten</span></div>';

            targetArea.appendChild(winnerBox);
        },

        /**
         * Ergebnis-Verdict aus den Auktionsdaten ableiten (identisch zur Loop-Logik).
         * 'reserve_not_met' setzt Gebote voraus — 0 Gebote sind immer 'ended'
         * (muss brandner_get_auction_end_state() in PHP entsprechen).
         */
        verdictFor: function(data) {
            var hasBids = parseFloat(data.current_bid) > 0 || parseInt(data.bid_count, 10) > 0;
            if (hasBids && (data.reserve_met === false || data.reserve_met === 0 || data.reserve_met === '0')) {
                return 'reserve_not_met';
            }
            if (data.is_winning === true) {
                return 'won';
            }
            return 'ended';
        },

        /**
         * Einheitliche Ergebnis-Texte — MUESSEN mit brandner-realtime.js und dem
         * PHP-Helfer brandner_auction_verdict_label() uebereinstimmen.
         */
        verdictLabel: function(verdict) {
            if (verdict === 'won') return 'Zuschlag erhalten';
            if (verdict === 'reserve_not_met') return 'Mindestpreis nicht erreicht';
            return 'Los beendet';
        },

        /**
         * Zeigt das Ergebnis-Banner sofort an der Bietbox an (idempotent, ohne Reload).
         */
        renderResultBanner: function(verdict, data) {
            if ($('.brandner-auction-result').length) return;

            var label = this.verdictLabel(verdict);
            var icon = (verdict === 'won') ? '🏆'
                     : (verdict === 'reserve_not_met') ? '🔒'
                     : '⏱';
            var priceHtml = '';
            if (verdict === 'won' && data.current_bid_formatted) {
                priceHtml = '<span class="result-price">' + data.current_bid_formatted + '</span>';
            }

            var $banner = $(
                '<div class="brandner-auction-result brandner-result--' + verdict + ' brandner-result--single">'
                + '<span class="result-icon">' + icon + '</span>'
                + '<span class="result-text">' + label + '</span>'
                + priceHtml
                + '</div>'
            );

            // Bevorzugt in/nach die Brandner-Bietbox, sonst nach den Timer
            var $anchor = $('.brandner-current-bid').first();
            if (!$anchor.length) $anchor = $('.uwa_auction_product_countdown').first();
            if ($anchor.length) {
                $anchor.after($banner);
            } else {
                $('.summary, .product_title').first().append($banner);
            }
        },

        /**
         * Zeigt "BEENDET" Status an
         */
        showEndedState: function() {
            var $timer = $('#uwa_auction_countdown, .uwa_auction_product_countdown').first();
            if ($timer.length) {
                // Timer durch "BEENDET" ersetzen oder Klasse hinzufuegen
                $timer.addClass('auction-ended');
            }
        },

        /**
         * Startet Polling mit dynamischem Intervall
         */
        startPolling: function() {
            var self = this;
            if (this.pollInterval) {
                clearInterval(this.pollInterval);
            }

            // Dynamisches Polling: Intervall anpassen basierend auf Timer-Status
            var schedulePoll = function() {
                if (self.auctionEnded) return;

                var interval = self.getPollInterval();
                self.pollInterval = setTimeout(function() {
                    self.poll();
                    schedulePoll(); // Naechsten Poll planen mit aktuellem Intervall
                }, interval);
            };

            schedulePoll();
        },

        /**
         * Visibility-Handler: Pausiert/Resumed bei Tab-Wechsel
         */
        initVisibilityHandler: function() {
            var self = this;
            document.addEventListener('visibilitychange', function() {
                if (document.hidden) {
                    // Tab versteckt - Polling pausieren (Countdown laeuft weiter)
                    if (self.pollInterval) {
                        clearTimeout(self.pollInterval);
                        self.pollInterval = null;
                        debugLog('[BrandnerProductRealtime] Polling pausiert (Tab versteckt)');
                    }
                } else {
                    // Tab wieder sichtbar - Polling fortsetzen und sofort synchronisieren
                    if (!self.pollInterval && !self.auctionEnded) {
                        self.startPolling();
                        self.poll(); // Sofort Server-Zeit holen um Drift zu korrigieren
                        debugLog('[BrandnerProductRealtime] Polling fortgesetzt (Tab sichtbar)');
                    }
                }
            });
        },

        /**
         * Manueller Force-Sync (kann von aussen aufgerufen werden)
         */
        forceSync: function() {
            debugLog('[BrandnerProductRealtime] Force-Sync angefordert');
            this.poll();
        },

        /**
         * Von den Bid-UIs nach ERFOLGREICHER eigener Gebotsabgabe aufgerufen.
         * Die Bid-Response ist autoritativ: Status sofort pinnen, damit stale
         * Polls (2s-Cache/5s-Transient) den Zustand nicht fuer Sekunden
         * zurueckdrehen ("Ueberboten" bleibt haengen obwohl man fuehrt).
         *
         * @param {number}  bidAmount  Eingegebener Betrag. Bei Maxbid 0 uebergeben —
         *                             der private Maximalwert darf nie als Preis
         *                             angezeigt/erzwungen werden (Ceiling-Leak).
         * @param {boolean} isMaxBid
         * @param {boolean} isWinning  Fuehrungsstatus laut Bid-Response (allstatus===1)
         */
        afterOwnBid: function(bidAmount, isMaxBid, isWinning) {
            var now = Date.now();
            this.userHasBid = true;
            this._statusPinUntil = now + 4000;
            this._statusPinWinning = isWinning === true;
            if (!isMaxBid && parseFloat(bidAmount) > 0) {
                this._optimisticUntil = now + 4000;
                this._optimisticBid = parseFloat(bidAmount);
            }
            debugLog('[BrandnerProductRealtime] afterOwnBid: pin=' + this._statusPinWinning +
                (isMaxBid ? ' (Maxbid)' : ' Betrag=' + bidAmount));

            // Sofort autoritativ nachladen + Reconciliation nach Pin-Ablauf
            var self = this;
            this.forceSync();
            setTimeout(function() { self.forceSync(); }, 4200);
        }
    };

    // Global verfuegbar machen (fuer Debugging und externe Aufrufe)
    window.BrandnerProductRealtime = BrandnerProductRealtime;

    // Initialisierung mit kurzer Verzoegerung (damit andere Scripts geladen sind)
    $(document).ready(function() {
        setTimeout(function() {
            BrandnerProductRealtime.init();
        }, 500);
    });

})(jQuery);
